import { Pipe, PipeTransform } from '@angular/core';
import { CondensedExperienceCommentModel } from '@inmoment/the-kitchen';

import { Document } from 'app/providers/storage-api/document.service';

@Pipe({
  name: 'experienceCardComments',
  standalone: false,
})
export class ExperienceCardCommentsPipe implements PipeTransform {
  transform(item: Document): CondensedExperienceCommentModel | CondensedExperienceCommentModel[] {
    return item.sectioned
      ? this.getSectionedComments(item)
      : { text: item?.analyses[0]?.redactedText ? item?.analyses[0].redactedText : item.text };
  }

  private getSectionedComments(document: Document): CondensedExperienceCommentModel[] {
    return document.analyses[0].flatSections.map((section) => ({
      title: section.name,
      text: section.value,
    }));
  }
}
